import {
  LdTablist,
  LdTabpanellist,
  LdTabs,
  LdTypo,
  LdTab,
  LdTabpanel,
} from "@emdgroup-liquid/liquid/dist/react";
import { StyledImg, StyledModal } from "@src/pages/HomePage/HomePage.style";
import { BarchartProps, ViewBEOProps } from "@src/types";
import { useRef, useEffect } from "react";
import {
  VictoryAxis,
  VictoryBar,
  VictoryChart,
  VictoryLabel,
  VictoryTooltip,
  VictoryTheme,
} from "victory";
import { StyledBarChart, StyledImgCard } from "./BarChart.style";

export const BarChart = ({ data, selectedEditWindow }: BarchartProps) => {
  const [selWindowFrom, selWindowTo] = selectedEditWindow;

  return (
    <StyledBarChart>
      <VictoryChart
        animate={{ duration: 1000 }}
        height={400}
        width={800}
        theme={VictoryTheme.material}
        padding={{ top: 8, right: 16, bottom: 80, left: 80 }}
      >
        <VictoryAxis
          label="Positions"
          axisLabelComponent={
            <VictoryLabel
              style={{
                fontSize: "12px",
              }}
              dy={32}
            />
          }
          tickLabelComponent={
            <VictoryLabel
              style={{
                fontSize: "8px",
                fill: "#444",
                fontWeight: ({ index }: any) =>
                  index + 1 >= selWindowFrom && index + 1 <= selWindowTo
                    ? "bold"
                    : "normal",
              }}
            />
          }
        />
        <VictoryAxis
          dependentAxis
          axisLabelComponent={
            <VictoryLabel style={{ fontSize: "12px" }} dy={-48} />
          }
          label="Comparative scores"
          tickLabelComponent={
            <VictoryLabel style={{ fontSize: "8px", fill: "#c0c0c0" }} />
          }
        />
        <VictoryBar
          labelComponent={
            <VictoryTooltip
              pointerLength={0}
              style={{ fontSize: "8px", padding: "0px" }}
            />
          }
          data={data}
          x="position"
          y="score"
          style={{
            data: {
              fill: ({ datum }) => (datum.y > 0 ? "#1f77b4" : "#1f77b4"),
            },
          }}
        />
      </VictoryChart>
    </StyledBarChart>
  );
};

export const ViewBaseEditingOutcome = ({
  barData,
  showModal,
  onModalClose,
  byStanderData,
  selectedEditWindow,
}: ViewBEOProps) => {
  const modalRef = useRef<any>(null);

  useEffect(() => {
    if (showModal) {
      showPopupModal();
    } else {
      hidePoupModal();
    }
  }, [showModal]);

  const showPopupModal = () => {
    modalRef?.current?.showModal();
  };

  const hidePoupModal = () => {
    modalRef?.current?.close();
    onModalClose();
  };

  const onClosing = () => hidePoupModal();
  return (
    <>
      <StyledModal
        ref={modalRef}
        onLdmodalclosing={onClosing}
        padding={"0px"}
        width="60%"
        height="75%"
      >
        <LdTypo slot="header">Base Editing Outcome</LdTypo>
        <LdTabs>
          <LdTablist>
            <LdTab selected> Bystander Prediction</LdTab>
            <LdTab>Edited Score Across The Window</LdTab>
          </LdTablist>
          <LdTabpanellist>
            <LdTabpanel>
              <StyledImgCard>
                {byStanderData && (
                  <StyledImg
                    src={`data:image/png;base64, ${byStanderData}`}
                    alt="ByStander Data"
                  />
                )}
              </StyledImgCard>
            </LdTabpanel>
            <LdTabpanel>
              <BarChart
                data={barData}
                selectedEditWindow={selectedEditWindow}
              />
            </LdTabpanel>
          </LdTabpanellist>
        </LdTabs>
      </StyledModal>
    </>
  );
};
